import { Api } from '@automapa/svelte-automapa-template';
import { RouteTypeApi } from './RouteTypeApi';
import { RouteType } from './RouteType';

export class RouteTypeListApp {
    private api: Api;
    private _items: RouteType[] = [];
    private _loaded: boolean = false;

    constructor(api: Api) {
        this.api = api;
    }

    public async getItems() {
        if (!this._loaded) {
            let response = await RouteTypeApi.getAll(this.api).catch(e => {
                console.error('RouteTypeListApp.getItems', e);
                return [];
            });
            this._items = response.map(data => {
                let item = new RouteType();
                item.set(data);
                return item;
            });
            this._loaded = true;
        }
        return this._items;
    }

    public async updateOne(rt: RouteType) {
        console.log('updateOne, rt', JSON.stringify(rt.get()));
        console.log('updateOne, rt.getRequest', JSON.stringify(rt.getRequest()));
        // update this._items
        this._items = this._items.map(item => {
            if (item.getId() === rt.getId()) {
                return rt;
            }
            return item;
        });
        // update DB
        return RouteTypeApi.updateOne(this.api, rt.getId(), rt.getRequest()).catch(e => {
            console.error('RouteTypeListApp.updateItem', e);
            return null;
        });
    }
}
